import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface LotusMarkProps {
    className?: string
}

const LotusMark: FC<LotusMarkProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='-32 -34 64 48'
            className={cn('size-8', className)}
            aria-hidden='true'
            focusable='false'
        >
            <path d='M0 -26 C7 -18 7 -6 0 2 C-7 -6 -7 -18 0 -26 Z' fill='#e9b949' />
            <path d='M0 2 C-2 -10 -10 -20 -19 -21 C-18 -10 -11 -2 0 2 Z' fill='#d9773b' />
            <path d='M0 2 C2 -10 10 -20 19 -21 C18 -10 11 -2 0 2 Z' fill='#d9773b' />
            <path d='M0 2 C-8 -4 -18 -8 -25 -5 C-20 2 -10 4 0 2 Z' fill='#b7412a' />
            <path d='M0 2 C8 -4 18 -8 25 -5 C20 2 10 4 0 2 Z' fill='#b7412a' />
            <path d='M-22 8 L22 8' stroke='#e9b949' strokeWidth='2.5' strokeLinecap='round' />
        </svg>
    )
}

export default LotusMark
